import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  AnswerByRecipient } from 'src/app/models/QuestionnaireDataByQuestions.model';
import { ContactCircleComponent } from '../contact-circle/contact-circle.component';
import { AnswerSwitchTypePipe } from '../../genery-column/answer-switch-type.pipe';
import { Question } from 'src/app/models/question.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { EQuestionType } from 'src/app/models/questionType.model';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-row-data',
    imports: [CommonModule, ContactCircleComponent, AnswerSwitchTypePipe, QueDatePipe, TranslateDirective, TranslatePipe],
    templateUrl: './row-data.component.html',
    styleUrls: ['./row-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RowDataComponent {
@Input()
answerByRecipient?:AnswerByRecipient;
@Input()
isSource?:boolean;
@Input()
question?:Question;
@Input()
filterRecipients?:number;
#storeData = inject(DataSummaryStore);
eQuestionType = EQuestionType;
showComparison$ = toSignal(this.#storeData.showComparison$);

}
